// @import dependencies
import React, { CSSProperties, useState, useEffect } from 'react'
// @end dependencies

// @import components
// @end components

// @import types
import * as ForumCategoryTypes from 'app_types/admin/forum/forumCategory.types';
// @end types

// @import services
// @end services

// @import hooks
// @end hooks

// @import actions
// @end actions

// @import utils
// @end utils

// @import assets
// @end assets

// @import styles
import './ForumCategoryModule.scss'
import ForumCategoryService from 'app_services/admin/forum/forumCategoryService';
import AlertComponent from 'app_components/commons/alert';
import TextComponent from 'app_components/commons/TextComponent/TextComponent';
import InputComponent from 'app_components/commons/Input/InputComponent';
import ButtonComponent from 'app_components/commons/Button/ButtonComponent';
// @end styles

interface IForumCategoryModuleProps {
  className?: string
  style?: CSSProperties
  id?: string

}

const ForumCategoryModule: React.FC<IForumCategoryModuleProps> = (props) => {

  const [categories, updateCategories] = useState<ForumCategoryTypes.ForumCategory[]>([]);
  const [name, updateName] = useState<string>('')
  const [loading, updateLoading] = useState<boolean>()

  // @INFO Servicios
  const forumCategoryService = new ForumCategoryService()

  useEffect(() => {
    getCategories()
  }, [])

  const getCategories = async () => {
    const response = await forumCategoryService.list({
      pageNumber: '1',
      nPerPage: '1000'
    })
    if (response?.code === 200 && response?.forumCategories) {
      updateCategories(response.forumCategories)
    }
  }

  const handleClickCreate = async () => {
    updateLoading(true)
    const response = await forumCategoryService.create({
      name
    })
    if (response?.code === 200 && response?.forumCategory) {
      getCategories()
      updateName('')
    }
    updateLoading(false)
  }

  return(
    <div
      className={`forum_category_module-layout ${props.className ? props.className : ''}`}
      style={props.style}
      id={props.id}
    >
      <TextComponent
        type='text'
        style={{fontWeight: 600}}
      >
        Crear categoría
      </TextComponent>
      <div className="form-create-category">
        <InputComponent
          placeholder='Nombre'
          onChange={(e) => updateName(e.target.value)}
          value={name}
        />
        <ButtonComponent
          variant='primary'
          loading={loading}
          disabled={!name.trim().length}
          onClick={handleClickCreate}
        >
          Crear
        </ButtonComponent>
      </div>
      {categories?.length ?
        categories.map((c) => (
          <div
            className="category-forum-item"
            key={c._id}
          >
            <TextComponent
              type='text'
              style={{fontWeight: 600}}
            >
              {c.name}
            </TextComponent>
          </div>
        ))
      :
        <AlertComponent description='Aún no hay categorías' />
      }
    </div>
  );
}

export default ForumCategoryModule;
